module.exports = __webpack_public_path__ + "img/christmas_bg.f5fb45aa.png";